<template>
    <div class="search-filter-flairs" v-if="loaded">

        <!--  Services Flairs Start  -->
        <template v-if="filterProp === 'services'">
            <flair-button v-for="service in servicesTemp" :key="'serviceTemp' + service"
                          :flair="service"
                          :flairText="getFlairServiceText(service)"
                          @click="onCrossClickServices(service)"
            ></flair-button>
        </template>
        <!--  Services Flairs End  -->

        <!--  Extra Content Flairs Start  -->
        <template v-if="filterProp === 'extraContent'">
            <flair-button v-for="contentName in Object.keys(extraContentTemp).filter(key => extraContentTemp[key])" :key="`extraContent${contentName}`"
                          :flairText="getFlairExtraContentText(contentName, extraContentTemp[contentName])"
                          @click="onCrossClickExtraContent(contentName, extraContentTemp[contentName])"
            ></flair-button>
        </template>
        <!--  Extra Content End  -->

        <!--  Category Flairs Start  -->
        <template v-if="filterProp === 'category'">
            <template v-if="lodash.isNil(categoryTemp.type)">
                <flair-button
                    :flair="constants.user_type.PROFESSIONAL"
                    :flairText="getFlairCategoryText('type', constants.user_type.PROFESSIONAL)"
                    @click="onCrossClickCategory(constants.user_type.PROFESSIONAL,'type')"
                ></flair-button>

                <flair-button
                    :flair="constants.user_type.AMATEUR"
                    :flairText="getFlairCategoryText('type',constants.user_type.AMATEUR)"
                    @click="onCrossClickCategory(constants.user_type.AMATEUR,'type')"
                ></flair-button>
            </template>

            <flair-button v-else-if="categoryTemp.type > -1"
                          :flair="categoryTemp.type"
                          :flairText="getFlairCategoryText('type',categoryTemp.type)"
                          @click="onCrossClickCategory(categoryTemp.type,'type')"
            ></flair-button>

            <template v-if="lodash.isNil(categoryTemp.meetingLocation)">
                <flair-button
                    :flair="constants.meeting_location.INCALL"
                    :flairText="getFlairCategoryText('meetingLocation',constants.meeting_location.INCALL)"
                    @click="onCrossClickCategory(constants.meeting_location.INCALL,'meetingLocation')"
                ></flair-button>

                <flair-button
                    :flair="constants.meeting_location.OUTCALL"
                    :flairText="getFlairCategoryText('meetingLocation',constants.meeting_location.OUTCALL)"
                    @click="onCrossClickCategory(constants.meeting_location.OUTCALL,'meetingLocation')"
                ></flair-button>
            </template>

            <flair-button v-else-if="categoryTemp.meetingLocation > -1"
                          :flair="categoryTemp.meetingLocation"
                          :flairText="getFlairCategoryText('meetingLocation',categoryTemp.meetingLocation)"
                          @click="onCrossClickCategory(categoryTemp.meetingLocation,'meetingLocation')"
            ></flair-button>

        </template>
        <!--  Category Flairs End  -->

        <!--  Features Flairs Start  -->
        <template v-if="filterProp === 'features'">
            <flair-button v-if="featuresTemp.cup_size && featuresTemp.cup_size.from"
                          :flair="featuresTemp.cup_size"
                          :flairText="getFlairFeaturesTextCupSize(featuresTemp.cup_size)"
                          @click="onCrossClickFeatures('cup_size')"
            ></flair-button>

            <flair-button v-if="featuresTemp.gender"
                          :flair="featuresTemp.gender"
                          :flairText="translateFeature(featuresTemp.gender, 'gender')"
                          @click="onCrossClickFeatures('gender')"
            ></flair-button>

            <flair-button v-for="(slider,name) in featuresTemp.sliders" :key="'features-slidersTemp' + name"
                          :flair="slider"
                          :flairText="getFlairFeaturesTextSlider(name,slider)"
                          @click="onCrossClickFeatures('sliders',name)"
            ></flair-button>

            <template v-for="(list,name,index1) in featuresTemp.lists">
                <flair-button v-for="(value,index2) in list" :key="'features-listsTemp' + index1 + '-'+ index2"
                              :flair="value"
                              :flairText="getFlairFeaturesTextList(name,value)"
                              @click="onCrossClickFeatures('lists',name,value)"
                ></flair-button>
            </template>
        </template>
        <!--  Features Flairs End  -->


        <!--  Outcall location Flairs Start  -->
        <template v-if="filterProp === 'outcall_locations'">
            <div>
                <div class="filter-flairs-outcall-location-block">
                    <span class="mr-2 filter-flairs-outcall-location-block-label">{{ translate.account.outcallActive }}</span>
                    <span>
                        <flair-button v-for="location in outcallLocationsActiveProp" :key="'outcall-location' + location.id"
                                      class="filter-badge--legacy"
                                      :flair="location.name"
                                      :flairText="location.name"
                                      @click="$emit('OutcallLocationCrossClick', location)"
                                      e2e-id="outcall-location-flair"
                                      :hide-close-button="hideCloseButton"
                        ></flair-button>
                    </span>
                </div>
            </div>

            <template v-if="outcallLocationsNotActiveProp && outcallLocationsNotActiveProp.length">
                <div class="filter-flairs-outcall-location-buy-gold-wrapper">
                    <p class="filter-flairs-outcall-location-buy-gold" v-if="!isInOnboardingMode">
                        <span>{{ isSilverUser(currentUser) ? translate.account.outcallToActivateMore : translate.account.outcallToActivateMoreSilver }}</span>
                        <a :href="regionRelativeUrl(NuxtRoutes.PRODUCTS.BUY_PREMIUM)">{{ translate.account.outcallToActivateBuyGold }}</a>
                    </p>
                </div>

                <div class="filter-flairs-outcall-location-block">
                    <span class="mr-2 filter-flairs-outcall-location-block-label">{{ translate.account.outcallInActive }}</span>
                    <span>
                        <flair-button v-for="location in outcallLocationsNotActiveProp" :key="'outcall-location-inactive' + location.id"
                                      :flair="location.name"
                                      :flairText="location.name"
                                      :disabled="true"
                                      @click="$emit('OutcallLocationCrossClick', location)"
                                      e2e-id="outcall-location-flair-inactive"
                                      :hide-close-button="hideCloseButton"
                        ></flair-button>
                    </span>
                </div>
            </template>


        </template>
        <!--  Outcall location Flairs End  -->

    </div>
</template>

<script>
import debounce from 'debounce';
import FlairButtonComponent from "@/components/partials/FlairButtonComponent";
import servicesFlairMixin from '../mixins/flairs/services-flairs-mixin';
import categoryFlairMixin from '../mixins/flairs/category-flairs-mixin';
import featuresFlairMixin from '../mixins/flairs/features-flairs-mixin';
import userMixin from "@/components/mixins/userMixin";
import extraContentFlairsMixin from "@/components/mixins/flairs/extra-content-flairs-mixin";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import {NuxtRoutes} from "@/core/constants/v2/nuxtRoutes";

const data = () => {
    return {
        lodash: _,
        store: $store,
        unSubscribe: null,
        loaded: false,
        fullServices: [],
        constants: constants,
        debounceTime: 400,
        NuxtRoutes,
    };
};

function onCrossClickServices(serviceId) {
    let services = _.cloneDeep(this.servicesTemp);
    _.remove(services, id => _.isEqual(id, serviceId));

    this.store.commit('setServicesTemp', services);
}

function onCrossClickCategory(value, subFilter) {
    let category = _.cloneDeep(this.categoryTemp);
    category = this.removeCategoryFlair(category, subFilter, value);

    this.store.commit('setCategoryTemp', category);
}

function onCrossClickExtraContent(subFilter) {
    let extraContent = _.cloneDeep(this.extraContentTemp);
    extraContent = this.removeExtraContentFlair(extraContent, subFilter);

    this.store.commit('setExtraContentTemp', extraContent);
}

function onCrossClickFeatures(filterName, subFilterName, value) {

    let features = _.cloneDeep(this.featuresTemp);

    if (filterName === 'cup_size') {
        delete features.cup_size;
    }

    if (filterName === 'gender') {
        // set `features.gender = null` to apply ALL gender filter
        // (null represents ALL as it's not part of the URL)
        // otherwise the search would fallback to the Female gender filter again
        features.gender = null;
    }

    if (filterName === 'sliders') {
        features = this.removeFeaturesFlairSlider(features, subFilterName)
    }

    if (filterName === 'lists') {
        features = this.removeFeaturesFlairList(features, subFilterName, value)
    }

    this.store.commit('setFeaturesTemp', features);
}

export default {
    data,
    created() {
        this.refreshSearch = debounce(this.refreshSearch, this.debounceTime);
        if (this.filterProp === 'outcall_locations') {
            this.loaded = true;
        }
    },
    mixins: [
        categoryFlairMixin,
        featuresFlairMixin,
        servicesFlairMixin,
        extraContentFlairsMixin,
        userMixin,
        regionsUrlMixin,
    ],
    computed: {
        ...mapState([
            'featuresTemp',
            'servicesTemp',
            'extraContentTemp',
            'categoryTemp',
            'allServices',
            'translate',
            'currentUser'
        ]),
    },
    watch: {
        allServices: {
            immediate: true,
            handler(val) {
                if (val && val.length) {
                    this.fullServices = val;
                    this.loaded = true;
                }
            },
        }
    },
    props: ['filterProp', 'outcallLocationsActiveProp', 'outcallLocationsNotActiveProp', 'hideCloseButton', 'isInOnboardingMode'],
    components: {
        'flair-button': FlairButtonComponent,
    },
    methods: {
        onCrossClickServices,
        onCrossClickCategory,
        onCrossClickFeatures,
        onCrossClickExtraContent,
    }
}
</script>
